var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnerPortal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 75.1 73.26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m22.55 30.01a5.43 5.43 0 1 0-5.43-5.43 5.44 5.44 0 0 0 5.43 5.43z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m44.1 54.15h25.6a0.4 0.4 0 0 0 0.4-0.4v-7.49a17.49 17.49 0 0 0-34.49-4.09 22.46 22.46 0 0 1 8.49 11.98z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m52.6 15.86a5.43 5.43 0 1 0-5.43-5.43 5.44 5.44 0 0 0 5.43 5.43z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m52.6 20.86a10.43 10.43 0 1 0-10.43-10.41 10.44 10.44 0 0 0 10.43 10.41zm0-15.86a5.43 5.43 0 1 1-5.43 5.43 5.43 5.43 0 0 1 5.43-5.41z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m52.55 23.86a22.5 22.5 0 0 0-21.46 15.8 22.49 22.49 0 0 0-31.09 20.74v7.46a5.4 5.4 0 0 0 5.4 5.4h34.2a5.4 5.4 0 0 0 5.4-5.4v-7.46-1.25h24.7a5.4 5.4 0 0 0 5.4-5.4v-7.49a22.49 22.49 0 0 0-22.55-22.4zm-12.55 36.54v7.46a0.4 0.4 0 0 1-0.4 0.4h-34.2a0.4 0.4 0 0 1-0.4-0.4v-7.46a17.5 17.5 0 0 1 33.82-6.25 17 17 0 0 1 1.11 5c0.03 0.42 0.07 0.83 0.07 1.25zm30.1-6.65a0.4 0.4 0 0 1-0.4 0.4h-25.6a22.46 22.46 0 0 0-8.49-12 17.49 17.49 0 0 1 34.49 4.11z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m22.55 35.01a10.43 10.43 0 1 0-10.48-10.43 10.44 10.44 0 0 0 10.48 10.43zm0-15.86a5.43 5.43 0 1 1-5.43 5.43 5.44 5.44 0 0 1 5.43-5.43z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerPortal);
export default __webpack_public_path__ + "static/media/partner-portal.4d1906e1.svg";
export { ForwardRef as ReactComponent };